<template>
  <PageWrapper
    isExtended
    :isLoading="isLoading"
    :hasFilters="true"
    @submitFilters="getAllMasterSalaries"
  >
    <template #title> لیست درآمد جلسات رزرو شده شما </template>
    <template #filters>
      <SearchInput
        inputId="studentUserFullname"
        inputLabel="جستجو بر اساس نام زبان آموز"
        inputPlaceholder="علی..."
        v-model="masterSalariesFilters.studentUserFullname"
        @enter="getAllMasterSalaries"
      ></SearchInput>
      <SearchInput
        inputId="schedualCount"
        inputLabel="جستجو بر اساس تعداد جلسات برگزار شده"
        inputPlaceholder="علی..."
        v-model.number="masterSalariesFilters.schedualCount"
        @enter="getAllMasterSalaries"
      ></SearchInput>
      <RangeDatePicker
        inputId="fromToDateRange"
        class="w-24 filters-width"
        label="بازه تاریخ درآمد (بر اساس تاریخ ثبت کلاس)"
        @getDateRange="setFromToDateRange"
      ></RangeDatePicker>
      <RangeDatePicker
        inputId="fromToScheduleDateRange"
        class="w-24 filters-width"
        label="بازه تاریخ درآمد (بر اساس تاریخ شروع کلاس)"
        @getDateRange="setFromToScheduleDateRange"
      ></RangeDatePicker>
      <PriceCategoryPicker
        @getPriceCategory="setPriceCategory"
        class="w-24 filters-width mr-md-2"
      ></PriceCategoryPicker>
    </template>
    <template #extend>
      <div>
        <p>
          مجموع درآمد استاد:
          <span class="text-primary">
            {{ Intl.NumberFormat("en-US").format(masterSumPrice) }}
          </span>
          تومان
        </p>
        <p>
          جمع دقایق تدریس شده:
          <span class="text-primary">
            {{ Intl.NumberFormat("en-US").format(masterSumMinute) }}
          </span>
          دقیقه
        </p>
      </div>
    </template>
    <CustomTable
      :pageNumber="masterSalariesFilters.pageNumber"
      :count="masterSalariesFilters.count"
      :totalCount="totalCount"
      :tableColumns="myTableColumns"
      :tableItems="salariesList"
      @changePage="changePage"
    >
      <template #studentUserFullname="data">
        <b-link :to="`/master/users/${data.item.studentUserId}`">
          {{ data.item.studentUserFullname }}
        </b-link>
      </template>
      <template #createDate="data">
        <span style="white-space: nowrap !important">
          {{ new Date(data.item.createDate).toLocaleDateString("fa-IR") }}
          -
          {{
            new Date(data.item.createDate).toLocaleTimeString("fa-IR", {
              hour: "2-digit",
              minute: "2-digit",
            })
          }}
        </span>
      </template>
      <template #schedualCount="data">
        <span style="white-space: nowrap">
          {{ data.item.schedualCount }}
          جلسه
        </span>
      </template>
      <template #basePrice="data">
        <span style="white-space: nowrap">
          {{ Intl.NumberFormat("en-US").format(data.item.basePrice) }}
          تومان
        </span>
      </template>
      <template #callPrice="data">
        <span style="white-space: nowrap">
          <template v-if="data.item.callPrice">
            {{ Intl.NumberFormat("en-US").format(data.item.callPrice) }}
            تومان
          </template>
          <template v-else> ندارد </template>
        </span>
      </template>
      <template #sumPlusCall="data">
        <span style="white-space: nowrap">
          <template v-if="data.item.callPrice">
            {{
              Intl.NumberFormat("en-US").format(
                data.item.sumPrice + data.item.callPrice
              )
            }}
            تومان
          </template>
          <template v-else>
            {{ Intl.NumberFormat("en-US").format(data.item.sumPrice) }}
            تومان
          </template>
        </span>
      </template>
      <template #sumPrice="data">
        <span style="white-space: nowrap">
          {{ Intl.NumberFormat("en-US").format(data.item.sumPrice) }}
          تومان
        </span>
      </template>
    </CustomTable>
  </PageWrapper>
</template>

<script>
export default {
  mounted() {
    this.getAllMasterSalaries();
  },
  data() {
    return {
      isLoading: false,
      sumSalary: null,
      salariesList: null,
      totalCount: null,
      fromToDateRange: null,
      fromToScheduleDateRange: null,
      masterSalariesFilters: {
        studentUserFullname: null,
        fromDate: null,
        toDate: null,
        fromDateSchedule: null,
        toDateSchedule: null,
        masterUserId: null,
        userfullname: null,
        userMobile: null,
        userNationalId: null,
        schedualCount: null,
        sumPrice: null,
        pageNumber: 1,
        count: 10,
        priceCategoryId: null,
      },
      masterSumPrice: null,
      masterSumMinute: null,
      myTableColumns: [
        {
          key: "id",
          label: "شناسه",
        },

        {
          key: "studentUserFullname",
          label: "نام زبان آموز",
        },
        {
          key: "priceCategoryTitle",
          label: "گروه بندی",
        },
        {
          key: "schedualCount",
          label: "تعداد جلسات برگزار شده",
        },
        {
          key: "createDate",
          label: "تاریخ ایجاد",
        },
        {
          key: "basePrice",
          label: "قیمت پایه هر جلسه",
        },
        {
          key: "callPrice",
          label: "هزینه تماس",
        },
        {
          key: "sumPrice",
          label: "میزان درآمد",
        },
        {
          key: "sumPlusCall",
          label: "جمع درآمد و تماس",
        },
      ],
    };
  },
  methods: {
    changePage(pageNumber) {
      this.masterSalariesFilters.pageNumber = pageNumber;
      this.getAllMasterSalaries();
    },
    setFromToDateRange(dateRange) {
      if (dateRange) {
        this.fromToDateRange = dateRange;
      } else {
        this.clearFromToDateRange();
      }
    },
    setFromToScheduleDateRange(dateRange) {
      if (dateRange) {
        this.fromToScheduleDateRange = dateRange;
      } else {
        this.clearFromToScheduleDateRange();
      }
    },
    setPriceCategory(priceCategoryId) {
      this.masterSalariesFilters.priceCategoryId = priceCategoryId;
    },
    clearFromToDateRange() {
      this.fromToDateRange = null;
      this.masterSalariesFilters.fromDate = null;
      this.masterSalariesFilters.toDate = null;
    },
    clearFromToScheduleDateRange() {
      this.fromToScheduleDateRange = null;
      this.masterSalariesFilters.fromDateSchedule = null;
      this.masterSalariesFilters.toDateSchedule = null;
    },
    calculateDates() {
      if (this.fromToDateRange && this.fromToDateRange.length > 0) {
        this.masterSalariesFilters.fromDate = new Date(
          this.fromToDateRange?.[0]
        );
        this.masterSalariesFilters.toDate = new Date(this.fromToDateRange?.[1]);
      }
      if (
        this.fromToScheduleDateRange &&
        this.fromToScheduleDateRange.length > 0
      ) {
        this.masterSalariesFilters.fromDateSchedule = new Date(
          this.fromToScheduleDateRange?.[0]
        );
        this.masterSalariesFilters.toDateSchedule = new Date(
          this.fromToScheduleDateRange?.[1]
        );
      }
    },
    async getAllMasterSalaries() {
      try {
        this.isLoading = true;
        let _this = this;
        let getMastersSalaryList = new GetMastersSalaryListForMaster(_this);
        getMastersSalaryList.setRequestParamDataObj(
          _this.handleMasterSalariesFilters()
        );
        await getMastersSalaryList.fetch((res) => {
          _this.salariesList = res.data;
          _this.totalCount = res.total;
          _this.masterSumPrice = res.sumPrice;
          _this.masterSumMinute = res.sumMinute;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    handleMasterSalariesFilters() {
      this.calculateDates();
      return this.masterSalariesFilters;
    },
  },
  computed: {
    computedMasterName() {
      if (this.salariesList && this.salariesList.length > 0) {
        return this.salariesList[0].userfullname;
      }
      return null;
    },
    computedMasterMobile() {
      if (this.salariesList && this.salariesList.length > 0) {
        return this.salariesList[0].userMobile;
      }
      return null;
    },
  },
  components: {
    PriceCategoryPicker,
    PageWrapper,
    SearchInput,
    RangeDatePicker,
    CustomTable,
    BLink,
  },
};
import PriceCategoryPicker from "@/views/apps/PriceCategory/PriceCategoryPicker.vue";
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import RangeDatePicker from "@/views/components/Utils/RangeDatePicker.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import { GetMastersSalaryListForMaster } from "@/libs/Api/MasterUserPayment";
import { BLink } from "bootstrap-vue";
</script>
